<template>
	<div class="network">
		<div class="container">
			<img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1551692278598&di=ce151d4fd5b7521477f0e88add68bf30&imgtype=0&src=http%3A%2F%2Fpic32.photophoto.cn%2F20140808%2F0006019019886851_b.jpg"/>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'network'
			}
		}
	}
	
</script>

<style lang="less" scoped="scoped">
.network{
	margin-top: 70px;
	margin-bottom: 70px;
	img{
		width: 100%;
		height: 700px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ContactUs/Ccom/Network.vue